import { useEffect } from 'react';

let callback: () => void = () => {};

const enterKeyHandler = (e: KeyboardEvent): void => {
	if (
		e.code.toLowerCase() === 'enter'
        || e.code.toLowerCase() === 'numpadenter'
	) {
		callback();
	}
};

export const useEnterKeyPress = (cb: () => void): void => {
	useEffect(() => {
		callback = cb;
		document.addEventListener('keypress', enterKeyHandler);

		return () => {
			document.removeEventListener('keypress', enterKeyHandler);
		};
	});
};
